module.exports = __webpack_public_path__ + "static/img/6.7edc254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/detect/6.jpg
// module id = oY9X
// module chunks = 13